module.exports = __webpack_public_path__ + "img/g2.a50f1b71.jpg";